import { UPLOAD_WEIGHT_DISCREPANCY_REQUEST, UPLOAD_WEIGHT_DISCREPANCY_SUCCESS, UPLOAD_WEIGHT_DISCREPANCY_FAILURE, } from "../../actions";
const initialState = {
    uploading: false,
    success: false,
    error: null,
    data: null,
};
const weightDiscrepancyfileUploadReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_WEIGHT_DISCREPANCY_REQUEST:
            return Object.assign(Object.assign({}, state), { uploading: true, success: false, error: null });
        case UPLOAD_WEIGHT_DISCREPANCY_SUCCESS:
            return Object.assign(Object.assign({}, state), { uploading: false, success: true, error: null, data: action.payload });
        case UPLOAD_WEIGHT_DISCREPANCY_FAILURE:
            return Object.assign(Object.assign({}, state), { uploading: false, success: false, error: action.payload });
        default:
            return state;
    }
};
export default weightDiscrepancyfileUploadReducer;
